import { paymentWelfare } from '@/api/index'

export function GET_YGDA_INFO () {
  return paymentWelfare.request({
    method: 'post',
    url: '/GET_YGDA_INFO'
  })
}
export function get_gzori (data: any) {
  return paymentWelfare.request({
    method: 'post',
    url: '/get_gzori',
    data
  })
}
